
import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import Profile from "../../assets/img/profile/profile.jpg"
import Button from "react-bootstrap/Button";

import './about.style.css';

const resumeHref = `${process.env.PUBLIC_URL || ""}/Muhammad_Abbas_CV.pdf`;

const About = () => {
    return (
        <div id='about'>
               <div className="about">
            <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
           <Container>
               <Row className="pt-3 pb-5 align-items-center">

                   <Col xs={12} md={6}>
                       <Row>
                       <Image className="profile justify-content-end" alt="profile" src={Profile} thumbnail fluid  />

                       </Row>

                   </Col>
                   <Col xs={12} md={6}>
                       <Row className=" align-items-start p-2 my-details rounded">
                           <p>Hi there! <strong>I am Muhammad Abbas</strong> — Senior Software Engineer.</p>
                           <p>
                           I have 13+ years of experience designing and delivering enterprise-grade fintech platforms,
                           payment systems, and educational analytics products. I work across <strong>.NET Core</strong>,{" "}
                           <strong>Next.js</strong>, <strong>React</strong>, microservices, and cloud architectures on{" "}
                           <strong>Azure</strong>, <strong>AWS</strong>, and <strong>GCP</strong>.
                           </p>
                           <p>
                           Over the last three years I have integrated AI-driven workflows into the development lifecycle using{" "}
                           Cursor AI, ChatGPT, and Claude — and shipped flagship AI products including the{" "}
                           <strong>iOLPay AI Dashboard Insights</strong> panel (live dashboard summaries, anomaly detection, and conversational Q&amp;A) and{" "}
                           <strong>Welbee EDU Intelligent</strong> (MAT-level survey analysis with comparative cross-school insights).
                           I translate leadership vision into scalable, maintainable, AI-enhanced engineering solutions.
                           </p>
                           <p className="mb-2">
                             <strong>Education</strong>
                           </p>
                           <ul className="pl-3 mb-3">
                             <li>Bachelor of Science in Computer Science — Gomal University, D.I. Khan (1st Division), 2007–2011</li>
                             <li>SQL for Data Analysis — online certification</li>
                           </ul>
                           <br /> <br />
                <Col className="d-flex justify-content-center flex-wrap">
                  <div>
                    <a href="#contact">
                      <Button className="m-2" variant="outline-primary">
                        Let's talk
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href={resumeHref} target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-success">
                        My Resume
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://github.com/abbasderawall/" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-dark">
                        GitHub
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://www.linkedin.com/in/muhammad-abbas-khan/" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-info">
                        LinkedIn
                      </Button>
                    </a>
                  </div>
                  <div>
                    <a href="https://join.skype.com/invite/lMvLAl2I4jB7" target="_blank" rel="noopener noreferrer">
                      <Button className="m-2" variant="outline-primary">
                        Skype
                      </Button>
                    </a>
                  </div>
                </Col>
                       </Row>

                   </Col>
               </Row>


           </Container>
        </div>
        </div>
    )
}

export default About
